import './sign-in.css';

import img1 from '../imgs/image1.png';

import { useContext, useState } from "react";
import { Button, IconBut } from "../ui/buttons";

import { useEffect } from "react";
import { useRef } from "react";
import { Host, Input } from '../App';
import { getCookie, StoreCookies } from '../utils';


export default function SignInModal({ show, set }) {
    const diaRef = useRef(null);


    useEffect(() => {
        const history = window.history;
        const dialog = diaRef.current;
        dialog.showModal();
        
        // to ensure sign-in states are pushed initially
        // and replaced when toggled
        if (["register", "login"].includes(history.state)) {
            history.replaceState(show, null, `/${show}`);
        } else {
            history.pushState(show, null, `/${show}`);
        }


        return () => dialog.close();
    }, [show])


    return (
        <dialog className="br-5 margin" ref={diaRef}>
            <div className="content max br-5">
                <div className="flex wrapper br-5 max">
                    <div className="flex mid-align mob" style={{ justifyContent: 'left', zIndex: 1, padding: '10px' }}>
                        <IconBut className="fa-solid fa-angle-left fa-lg" onClick={close} />
                    </div>
                    <div className="aes-bg max" style={{ padding: "50px" }}>
                        <div className='max bg-img' style={{ backgroundImage: `url(${img1})` }}>
                            {/* <h4 className="abs-mid center-text">
                                {txt}
                            </h4> */}
                        </div>
                    </div>
                    <Form action={show} setSignIn={set} closeModal={close} />
                </div>
                <div className="abs lap" style={{ left: "100%", bottom: "100%", zIndex: 1 }}>
                    <IconBut className="fa-solid fa-xmark fa-lg" onClick={close} />
                </div>
            </div>
        </dialog>
    )

    function close(){
        window.history.replaceState('', null, '/');
        set(false);
    }

}


function Form({ action, setSignIn, closeModal }) {
    const [status, setStatus] = useState({ act: "typing" });

    let txt, path, submitAction, fauxPath;

    if (action === "login") {
        txt = "Welcome back";
        path = fauxPath = "/auth/jwt/create";

    } else {
        txt = "SignUp";
        path = "/auth/users";
    }

    const error = status?.error, pending = status?.act === "pending";


    return (
        <form method="post" action={`${Host + action}`} onSubmit={signIn}>
            <h4 className="center-text">
                {txt}
            </h4>
            <div className='alert alert-danger' style={{ opacity: error ? 1 : 0 }}>
                {error ?? ''}
            </div>
            <div className="form-body">
                <Input id="namefield" label="Username" required autoFocus></Input>
                <Input id="passfield" key={error ? {} : action} type="password" label="Password"></Input>

                {action === "login" &&
                    <div className="flex" style={{ justifyContent: "right" }}>
                        <a className="my-a" href="/forgot"> forgot password? </a>
                    </div>
                }

                <Button className="br-1 margin" style={{ "--btn-bg": "var(--tert-col)" }} type="submit">
                    <span style={{ opacity: pending ? 0.5 : 1 }}>
                        {action === "login" ? "Log in" : "Sign up"}
                    </span>
                    {pending && <span className='abs-mid'>
                        <i className='fa-solid fa-spinner fa-spin'></i>
                    </span>
                    }
                </Button>
                <div className='fw'>
                    <hr></hr>
                    <span className='abs-mid hr-txt'> Or </span>
                </div>
                <div className="flex mid-align even-space" >
                    <Button className="br-1 margin" style={{ "--btn-bg": "transparent" }}> Google </Button>
                    <Button className="br-1 margin" style={{ "--btn-bg": "transparent" }}> Facebook </Button>
                </div>
                <p className='flex mid-align gap-2'>
                    {action === "login" ?
                        <> 
                            <span> Don't have an account yet? </span>
                            <a className="my-a" href="/register" onClick={e => setMode(e, "register")}>
                                Sign Up
                            </a>
                        </>
                        :
                        <> 
                            <span> Already using LearnXcess? </span>
                            <a className="my-a" href="/login" onClick={e => setMode(e, "login")}>
                                Log In
                            </a>
                        </>
                    }
                </p>
            </div>
        </form>
    )
    
    function setMode(e, mode) {
        e.preventDefault();
        setSignIn(mode)
    }


    async function signIn(ev) {
        ev?.preventDefault?.()
        const fd = new FormData(ev.target);

        // add csrf token
        fd.append("csrf", getCookie("csrf"));

        setStatus({ act: "pending" })

        if (action !== "Login") {
            createUser(fd, path)
                .then(_ => {
                    login(fd, fauxPath)
                })
                .catch(reason => {
                    setStatus({ error: reason.detail || reason })
                });

        } else login(fd, path)

        // submit
        // .then (res, rej)
        // catch errors
        // show errors
        // reset fields or redirect
    }


    async function login(formData, path) {

        // submit
        fetch(`${Host + path}`, {
            method: "post",
            body: formData, path
        })
            .then(res => res.json())
            .then(({ refresh, access }) => {
                // store refresh and access token in cookie jar
                setStatus("success");

                StoreCookies([
                    { name: "refresh", value: refresh, httpsOnly: true },
                    { name: "access", value: access, httpsOnly: true }
                ]);

                // redirect
                window.location.replace("/app");
            })
            .catch(reason => {
                setStatus({ error: reason.detail || reason })
            });
    }
}


async function createUser(formData, path) {

    return fetch(`${Host + path}`, {
        method: "post",
        body: formData
    }).then(res => res.json())
}


